import React from 'react';
import { CheckCircle2, AlertTriangle, ExternalLink } from 'lucide-react';

const MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const YEARS = { 2020: 'dos mil veinte', 2021: 'dos mil veintiuno', 2022: 'dos mil veintidos', 2023: 'dos mil veintitres', 2024: 'dos mil veinticuatro', 2025: 'dos mil veinticinco', 2026: 'dos mil veintiseis', 2027: 'dos mil veintisiete' };
const STEMS = [['rechaz', /rechaz|confirm|desestim/], ['confirm', /confirm|rechaz|desestim/], ['acog', /acog|revoc|anul|ha lugar/], ['revoc', /revoc|acog/], ['anul', /anul|acog|invalid/], ['inadmis', /inadmis/]];

// Deterministic check of each citation datum against the published ruling data
export const citationChecks = (text, f) => {
  const t = norm(text);
  const [y, m] = (f.fecha || '').split('-').map(Number);
  const res = norm(f.resultado);
  const stem = STEMS.find(([k]) => res.includes(k));
  const party = norm((f.caratulado || '').split(/[/]| con /i)[0]).trim().split(/\s+/).slice(0, 2).join(' ');
  const sala = norm(f.sala || '').trim();
  return [
    ['Rol', f.rol, !!f.rol && t.includes(norm(f.rol))],
    ['Sala', f.sala, !!sala && (t.includes(sala) || t.includes(sala.replace(' sala', ' sala de')))],
    ['Fecha', f.fecha, !!y && (t.includes(String(y)) || t.includes(YEARS[y] || '#')) && (!m || t.includes(MONTHS[m - 1]) || t.includes(`-${String(m).padStart(2, '0')}-`))],
    ['Resultado', f.resultado, !stem || stem[1].test(t)],
    ['Carátula', f.caratulado, !party || t.includes(party)],
  ].map(([dato, valor, ok]) => ({ dato, valor, ok }));
};

export const RulingSource = ({ f, text, testid }) => {
  const checks = citationChecks(text, f);
  return (
    <div data-testid={testid} className="space-y-1.5 rounded border border-slate-700 bg-slate-900/70 p-2 text-[11px]">
      <p className="font-semibold text-slate-200">Fallo publicado (Poder Judicial)</p>
      <p className="text-slate-300">{f.tribunal} · {f.sala} · Rol {f.rol} · {f.fecha}</p>
      <p className="text-slate-400">{f.caratulado}{f.juzgado ? ` · origen: ${f.juzgado}` : ''}{f.materia ? ` · ${f.materia}` : ''} · {f.recurso} · <b>{f.resultado}</b></p>
      {f.ministros?.length > 0 && <p className="text-slate-400">Ministros: {f.ministros.join(', ')}{f.redactor ? ` · redactor: ${f.redactor}` : ''}</p>}
      <ul data-testid={`${testid}-checks`} className="space-y-0.5">
        {checks.map((c) => (
          <li key={c.dato} data-testid={`${testid}-check-${c.dato}`} className={`flex items-center gap-1 ${c.ok ? 'text-emerald-300' : 'text-amber-300'}`}>
            {c.ok ? <CheckCircle2 className="h-3 w-3" /> : <AlertTriangle className="h-3 w-3" />}{c.dato}: {c.ok ? 'coincide con la cita' : `no figura o no coincide en la cita (publicado: ${c.valor || '—'})`}
          </li>
        ))}
      </ul>
      <p className="text-[10px] font-semibold uppercase text-slate-500">Texto público del fallo</p>
      <div data-testid={`${testid}-text`} className="max-h-48 overflow-y-auto whitespace-pre-line rounded bg-slate-950 p-1.5 text-slate-300">{f.texto || 'El buscador no publica extracto de este fallo.'}</div>
      <p className="text-[10px] text-slate-500">El buscador público entrega el texto disponible sin inicio de sesión; el documento íntegro puede requerir ingresar a juris.pjud.cl.{f.url && <a href={f.url} target="_blank" rel="noreferrer" className="ml-1 inline-flex items-center gap-0.5 text-sky-300">Abrir en juris.pjud.cl<ExternalLink className="h-2.5 w-2.5" /></a>}</p>
    </div>
  );
};
